// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MedicineBoxTwoToneSvg from "@fishx/icons-svg/es/asn/MedicineBoxTwoTone";
import FishxIcon from '../components/FishxIcon';

var MedicineBoxTwoTone = function MedicineBoxTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MedicineBoxTwoToneSvg
  }));
};

MedicineBoxTwoTone.displayName = 'MedicineBoxTwoTone';
export default React.forwardRef(MedicineBoxTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MedicineBoxTwoTone.js
// module id = 3102
// module chunks = 0